import MenuManager from '@yooink/youtils/es/MenuManager';
import { IoAnalytics } from 'react-icons/io5';
import { Route } from 'react-router-dom';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import Container from 'reactstrap/es/Container';
import { Block } from '@yooink/youi/dist/Layout/Block';
import { NevigationAnalytics } from './Navigation';
import { PromocodeDetails } from './pages/Details';

MenuManager.RegisterItem({
	key: 'analytics',
	path: '/analytics',
	name: 'Аналитика',
	icon: <IoAnalytics />,
	position: 4,
	acl: 'analytics'
});

export function AnalyticsRoute ({ path: basePath = '/analytics' }) {
	const getPath = (...path) => `${basePath}/${path.join('/')}`;

	const salesPage = useLoadComponent(() => import('./pages/sales').then((m) => m.SalesPage), {});
	const amocrmPage = useLoadComponent(() => import('./pages/amocrm').then((m) => m.AmoCrmPage), {});
	const clientsPage = useLoadComponent(() => import('./pages/clients').then((m) => m.ClientsPage), {});
	const promocodePage = useLoadComponent(() => import('./pages/promocodePage').then((m) => m.PromocodePage), {});
	const promocodeDetailsPage = useLoadComponent(() => import('./pages/Details').then((m) => m.PromocodeDetails), {});
	return (

		<Route
			path={getPath()}
			render={() => (
				<>
					<Container>
						<Block>
							<NevigationAnalytics basePath={getPath()} />
							<Route exact path={getPath()} component={salesPage} />
							<Route exact path={getPath('amocrm')} component={amocrmPage} />
							<Route exact path={getPath('clients')} component={clientsPage} />
							<Route exact path={getPath('promocode')} component={promocodePage} />
							<Route exact path={getPath('details')} component={promocodeDetailsPage} />
						</Block>
					</Container>
				</>
			)}
		/>

	);
}
